// Shared progress-status chip palette — single source of truth for the
// "unprocessed / dispatched / ... / cancelled" status chips rendered across
// Orders, Analysis, and Review.
export const getProgressStatusStyle = (s) => {
  const norm = (s || "").toLowerCase().replace(/[_\s]/g, " ").trim();
  switch (norm) {
    case "unprocessed":
    case "unknown":
    case "pending":
      return { backgroundColor: "#f5f5f5", color: "#9E9E9E", border: "1px solid #9E9E9E", dot: { backgroundColor: "transparent", border: "1.5px solid #9E9E9E" } };
    case "dispatched":
      return { backgroundColor: "#e3f2fd", color: "#2196F3", border: "1px solid #2196F3", dot: { backgroundColor: "#2196F3", border: "none" } };
    case "received by customer":
      return { backgroundColor: "#e8f5e8", color: "#4CAF50", border: "1px solid #4CAF50", dot: { backgroundColor: "#4CAF50", border: "none" } };
    case "returned to lab":
      return { backgroundColor: "#fff3e0", color: "#FF9800", border: "1px solid #FF9800", dot: { backgroundColor: "transparent", border: "1.5px solid #FF9800" } };
    case "processing":
      return { backgroundColor: "#f3e5f5", color: "#9C27B0", border: "1px solid #9C27B0", dot: { backgroundColor: "#9C27B0", border: "none" } };
    case "analysis completed":
      return { backgroundColor: "#e8eaf6", color: "#3F51B5", border: "1px solid #3F51B5", dot: { backgroundColor: "#3F51B5", border: "none" } };
    case "completed":
      return { backgroundColor: "#e8f5e8", color: "#2E7D32", border: "1px solid #2E7D32", dot: { backgroundColor: "#2E7D32", border: "none" } };
    case "cancelled":
      return { backgroundColor: "#ffebee", color: "#F44336", border: "1px solid #F44336", dot: { backgroundColor: "transparent", border: "1.5px solid #F44336" } };
    default:
      return { backgroundColor: "#f5f5f5", color: "#9E9E9E", border: "1px solid #9E9E9E", dot: { backgroundColor: "transparent", border: "1.5px solid #9E9E9E" } };
  }
};
